import { render, staticRenderFns } from "./IntegerComponent.vue?vue&type=template&id=257da642&"
import script from "./IntegerComponent.vue?vue&type=script&lang=ts&"
export * from "./IntegerComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports